import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Profiles from './Administration/Profiles';
import Admins from './Administration/Admins';
import Schools from './Schools'; // Assuming Schools is in BO/Schools.tsx, but imported here as sibling or absolute?
// Wait, Administration is in BO/Administration.tsx, Schools is in BO/Schools.tsx.
// So import Schools from '../Schools';
import { useAuth } from '../../context/AuthContext';
import './Administration/Administration.css';

type AdministrationSection = 'profiles' | 'admins' | 'settings' | 'schools';

const Administration: React.FC = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState<AdministrationSection>('profiles');

  const { userType } = useAuth(); // Assuming useAuth provides userType

  const sections: { key: AdministrationSection; label: string }[] = [
    { key: 'profiles', label: t('administration.profiles') },
    { key: 'admins', label: t('administration.admins') },
  ];

  if (userType === 'SUPER_ADMIN') {
    sections.push({ key: 'schools', label: t('school.school') });
  }

  const renderSection = () => {
    switch (activeSection) {
      case 'profiles':
        return <Profiles />;
      case 'admins':
        return <Admins />;
      case 'schools':
        return <Schools />;
      default:
        return <div>Section coming soon...</div>;
    }
  };

  return (
    <div className="administration-container">
      <div className="administration-header">
        <h2>{t('administration.title')}</h2>
      </div>

      <div className="administration-tabs">
        {sections.map((section) => (
          <button
            key={section.key}
            className={`tab-button ${activeSection === section.key ? 'active' : ''}`}
            onClick={() => setActiveSection(section.key)}
          >
            {section.label}
          </button>
        ))}
      </div>

      <div className="tab-content">
        {renderSection()}
      </div>
    </div>
  );
};

export default Administration;

